import { useState, useEffect, createContext, useContext } from 'react';
import { getMe, logout as logoutApi } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const res = await getMe();
      setUser(res.data);
    } catch {
      setUser(null);
      localStorage.removeItem('bunchh_token');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    if (token) localStorage.setItem('bunchh_token', token);
  };

  const logout = async () => {
    try { await logoutApi(); } catch {}
    setUser(null);
    localStorage.removeItem('bunchh_token');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
